import {Matrix4} from "@cm/math"
import type {ObjectLikeNode} from "#template/nodes/object/fundamental"
import {DimensionGuides} from "#template/nodes/object/dimension-guides"
import type {BoundsEdge} from "#template/utils/scene-geometry-utils"

export const initDimensionGuides = (name: string, parent: ObjectLikeNode | null, offset: number = 5, boundsEdge: BoundsEdge = "auto") => {
    return new DimensionGuides({
        parameters: {
            name,
            visible: true,
            lockedTransform: Matrix4.identity().toArray(),
            parent,
            concealable: false,
            offset,
            guides: [
                {boundsEdge, show: true},
                {boundsEdge, show: true},
                {boundsEdge, show: true},
            ],
            unitForDisplay: "cm",
        },
    })
}
